import { Button, Card } from "@mui/material";
import React from "react";

import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import { toggleUnenrollModal } from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";
import CommunicationLog from "components/common/communicationLog/CommunicationLog";
import useReminderHistoryLog from "./hooks/useReminderHistoryLog";
import PatientLiveCall from "./popover/PatientLiveCall";

const ReminderHistoryLog = (props) => {
  const { rowData } = props;
  const { data, isLoading, dispatch } = useReminderHistoryLog();

  return (
    <div
      style={{
        width: "100%",
        padding: "8px 24px",
        background: "#f5f5f5",
      }}
    >
      <Card
        className="d-flex justify-between align-items-center"
        style={{
          height: "50px",
          padding: "12px",
          borderRadius: 0,
          border: "1px solid #E0E0E0",
          boxShadow: "none",
        }}
      >
        <div>
          <h3>{rowData?.name} - History</h3>
        </div>
        <div>
          <Button
            variant="outlined"
            color="secondary"
            className="preferences-edit-button"
            onClick={(e) => {
              e.stopPropagation();
              dispatch(
                toggleUnenrollModal({
                  showModal: true,
                  patient: rowData,
                })
              );
            }}
          >
            <PersonRemoveOutlinedIcon fontSize="small" className="mr-2" />
            Deactivate Patient
          </Button>

          <PatientLiveCall
            summaryDetail={rowData?.live_call_reminder}
            patientId={rowData?._id}
          />
        </div>
      </Card>

      <CommunicationLog data={data?.logs || []} isLoading={isLoading} />
    </div>
  );
};

export default ReminderHistoryLog;
